var _title, _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBancontact = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 93 64"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", {
  id: "provider-bancontact"
}, "Bancontact")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: 16.01,
  x2: 43.97,
  y1: 48.99,
  y2: 59.37,
  gradientTransform: "matrix(1 0 0 -1 0 81)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#005ab9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1e3764"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: 48.82,
  x2: 78.5,
  y1: 56.04,
  y2: 66.16,
  gradientTransform: "matrix(1 0 0 -1 0 81)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fba900"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ffd800"
})))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M3.2 0h86.6A3.2 3.2 0 0 1 93 3.2v57.6a3.2 3.2 0 0 1-3.2 3.2H3.2A3.2 3.2 0 0 1 0 60.8V3.2A3.2 3.2 0 0 1 3.2 0",
  "data-name": "rounded white background"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#1e3764",
  d: "M8.28 55.53v-11h3.41c2.47 0 4.07.93 4.07 2.85a2.57 2.57 0 0 1-1.22 2.29 2.72 2.72 0 0 1 1.63 2.63c0 2.22-1.63 3.26-4.15 3.26zm2.19-6.45h1.63c1 0 1.42-.48 1.42-1.38s-.78-1.28-1.82-1.28h-1.23zm0 4.53h1.36c1.33 0 2.1-.33 2.1-1.37s-.66-1.45-1.91-1.45h-1.55zm10 2.11c-2.16 0-3.25-1-3.25-2.47s1.28-2.48 3.17-2.49a9 9 0 0 1 1.4.12v-.38c0-1-.55-1.42-1.6-1.42a5.7 5.7 0 0 0-2.09.38l-.39-1.7a8 8 0 0 1 2.73-.47c2.32 0 3.47 1.23 3.47 3.36V55a7.94 7.94 0 0 1-3.44.69zm1.32-1.78v-1.69a5.2 5.2 0 0 0-1.12-.12c-.72 0-1.29.28-1.29 1s.47 1 1.31 1a2.44 2.44 0 0 0 1.1-.22zm3.65 1.59V48a9.7 9.7 0 0 1 3.56-.71c2.3 0 3.62 1.13 3.62 3.23v5h-2.21v-4.84c0-1.09-.51-1.59-1.47-1.59a3.3 3.3 0 0 0-1.39.28v6.16zm14.8-7.77-.41 1.72a5 5 0 0 0-1.78-.4c-1.28 0-2 .9-2 2.39s.72 2.46 2.08 2.46a4.6 4.6 0 0 0 1.75-.41l.35 1.75a5.4 5.4 0 0 1-2.28.45 3.84 3.84 0 0 1-4.13-4.19c0-2.56 1.5-4.24 4-4.24a5.9 5.9 0 0 1 2.38.47zm4.7 8C42.46 55.72 41 54 41 51.5s1.51-4.21 3.94-4.21 3.88 1.71 3.88 4.21-1.48 4.22-3.93 4.22zm0-1.79c1.12 0 1.71-.93 1.71-2.43s-.59-2.42-1.71-2.42-1.72.94-1.72 2.42.62 2.43 1.72 2.43m5.19 1.6V48a9.6 9.6 0 0 1 3.56-.69c2.31 0 3.63 1.13 3.63 3.23v5H55.1v-4.86c0-1.09-.51-1.59-1.47-1.59a3.3 3.3 0 0 0-1.39.28v6.16zm12.1.19c-1.88 0-2.84-1-2.84-3.1v-3.45h-1.12v-1.73h1.07v-1.75l2.18-.11v1.86h1.75v1.73h-1.75v3.38c0 .91.38 1.34 1.09 1.34a4.6 4.6 0 0 0 .83-.1l.11 1.75a5.7 5.7 0 0 1-1.37.14zm5.5 0c-2.17 0-3.25-1-3.25-2.47s1.27-2.48 3.17-2.49a9 9 0 0 1 1.4.12v-.42c0-1-.55-1.42-1.61-1.42a5.7 5.7 0 0 0-2.08.38l-.39-1.7a7.8 7.8 0 0 1 2.72-.47c2.32 0 3.47 1.23 3.47 3.36V55a7.9 7.9 0 0 1-3.43.69zM69 53.94v-1.69a5.3 5.3 0 0 0-1.12-.12c-.73 0-1.29.28-1.29 1s.47 1 1.31 1a2.46 2.46 0 0 0 1.1-.22zm9.56-6.18-.41 1.72a5 5 0 0 0-1.78-.4c-1.28 0-2 .9-2 2.39s.72 2.46 2.08 2.46a4.6 4.6 0 0 0 1.75-.41l.35 1.75a5.4 5.4 0 0 1-2.27.45 3.84 3.84 0 0 1-4.14-4.19c0-2.56 1.5-4.24 4-4.24a5.9 5.9 0 0 1 2.38.47zm4.79 8c-1.88 0-2.84-1-2.84-3.1v-3.45h-1.07v-1.73h1.07v-1.75l2.17-.11v1.86h1.76v1.73h-1.76v3.38c0 .91.38 1.34 1.09 1.34a5 5 0 0 0 .84-.1l.11 1.75a5.7 5.7 0 0 1-1.37.14z",
  "data-name": "Bancontact"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  d: "M23.46 39C35 39 40.74 31.3 46.5 23.63H8.28V39z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#b)",
  d: "M69.54 8.28C58 8.28 52.26 16 46.5 23.63h38.22V8.28z"
})));
export { SvgBancontact as ReactComponent };